import { type FC } from 'react'
import { IntegrationIcon } from '../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../common/integrations'
import { getSupportedProviderFromAdhocMeetingLink, type SupportedMeetingProvider } from '../../../common/meetingProviders'
import { MeetingMode } from '../../../models/Scheduling'

interface ProviderConfig {
  serviceId: IntegrationServiceId
  label: string
}

const PROVIDER_CONFIG: Partial<Record<SupportedMeetingProvider, ProviderConfig>> = {
  zoom: { serviceId: IntegrationServiceId.ZOOM, label: 'Zoom' },
  teams: { serviceId: IntegrationServiceId.TEAMS, label: 'Teams' },
  meet: { serviceId: IntegrationServiceId.MEET, label: 'Google Meet' },
}

interface ProviderBadgeProps {
  meetingMode?: MeetingMode
  meetingUrl?: string
}

export const ProviderBadge: FC<ProviderBadgeProps> = ({ meetingMode, meetingUrl }) => {
  if (meetingMode === MeetingMode.IN_PERSON) {
    return <span className='paragraph-small zocks-bg-color-primary-light zocks-text-primary-dark rounded-3 px-2 py-1'>In person</span>
  }

  const provider = meetingUrl ? getSupportedProviderFromAdhocMeetingLink(meetingUrl) : undefined
  const config = provider ? PROVIDER_CONFIG[provider] : undefined
  if (config) {
    return (
      <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-gray-100 zocks-text-gray-900 rounded-3 px-2 py-1'>
        <IntegrationIcon serviceId={config.serviceId} width={16} height={16} />
        {config.label}
      </span>
    )
  }

  return (
    <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-cyan zocks-text-dark-green rounded-3 px-2 py-1'>
      <i className='bi bi-camera-video' />
      Video call
    </span>
  )
}
